const exportTable = {
  data() {
    return {
      downloadOrderDialog: false
    };
  },
  methods: {
    async getDownloadUrl() {
      let returnUrl = true;
      if (this.rowsAmount * this.page > 100000) {
        returnUrl = false;
      }
      const { url } = await this.$api.analyticsBlocking.getDownloadUrl(
        Object.assign({}, this.downloadRequisites, {
          returnUrl
        })
      );
      if (returnUrl) {
        window.open(url, "_blank");
      } else {
        this.downloadOrderDialog = true;
      }
    },
    downloadDialogClosed() {
      this.downloadOrderDialog = false;
    }
  }
};

export default exportTable;
